<template>
    <div>
      <section id="sekce-medicom" style="max-width: 100vw;">
        <div class="medicom-bg">
          <div class="medicom-heading">
            <div class="container">
              <div class="medicom-heading">
                <h2>MEDIOM CLINIC</h2>
              </div>
            </div>
          </div>
          <img class="medicom-imtro-img" src="/theme/images/klienti/medicom.jpg" alt="">
          <div class="carusel-container" ref="caruselContainer">
            <div class="carusel-wrapper">
              <div class="carusel-item" v-for="(item, index) in caruselItems" :key="index">
                <img :src="item.src" alt="">
                <div class="carusel-item-text-wrapper">
                  <h3>Krásnější díky plastice</h3>
                  <p class="typ">Web</p>
                </div>
              </div>
            </div>
          </div>
          <div class="carusel-bottom-space"></div>
        </div>
      </section>
    </div>
  </template>
<script>
import { animate, scroll } from "motion";
export default {
  data() {
    return {
      caruselItems: [
        { src: '/theme/images/klienti/medicom_karusel_1.jpg' },
        { src: '/theme/images/klienti/medicom_karusel_2.jpg' },
        { src: '/theme/images/klienti/medicom_karusel_3.jpg' },
        { src: '/theme/images/klienti/medicom_karusel_2.jpg' },
        { src: '/theme/images/klienti/medicom_karusel_3.jpg' },
        { src: '/theme/images/klienti/medicom_karusel_2.jpg' },
      ],
      isMouseInside: false,
    };
  },
  mounted() {
    const items = document.querySelectorAll(".carusel-item");
    // Animate gallery horizontally during vertical scroll
    scroll(
      animate(".carusel-wrapper", {
        transform: ["none", `translateX(-${(items.length - 1)/5}00vw)`]
      }),
      { target: document.querySelector(".carusel-container") }
    );
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
body{
}
.medicom-imtro-img {
  width: 100%;
}
.medicom-heading {
  position: absolute;
  top: 0px;
  width: 100%;
  padding-top: 90px;
}
.medicom-bg {
  background-color: #f1efef;
  padding-top: 90px;
  position: relative;
}
.carusel-bottom-space {
  position: relative;
  z-index: 2;
  background-color: #f1efef;
  height: 90px;
  width: 100%;
}
.medicom-heading h2 {
  font-size: 160px;
  font-weight: 600;
  background: linear-gradient(to right, #da188d, #5f2756);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  line-height: 1;
}
.medicom-heading {
  margin-bottom: 90px;
}
.carusel-container {
  // overflow-x: scroll;
  position: relative;
  min-height: 800px;
  margin-bottom: -20px;
  height: 250vh;
}
.carusel-wrapper {
  // position: absolute;
  // top: 0px;
  // left: 0px;
  position: sticky;
  top: 0px;
  padding-left: 200px;
  padding-right: 200px;
  display: flex;
  align-items: center;
  gap: 90px;
  height: 100vh;
}
.carusel-item {
  width: 25vw;
  flex: 0 0 auto;
}
.carusel-item img {
  width: 100%;
}
.carusel-item-text-wrapper {
  margin-left: 30px;
  margin-top: 30px;
}
.carusel-item-text-wrapper h3 {
  font-size: 45px;
  line-height: 1;
  font-weight: 600;
}
.typ {
  font-size: 25px;
  color: rgba(25, 27, 29, 0.6);
  line-height: 1;
  font-weight: 600;
}
</style>